import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import { MixPanelTrackedLink } from "../MixPaneTrackedLink";
import { StyledModal } from "./styles/BigModalLayoutStyles";

export function ModalLayout({
    open,
    setOpen,
    title,
    children,
    leftButtonLabel = null,
    onClickLeft,
    leftButtonLoading,
    rightButtonLabel = null,
    onClickRight,
    loadingRight,
    disabledRight,
    // subtitle = null
}) {
    const handleClose = () => setOpen(false);
    return <React.Fragment>
        <StyledModal
            open={open}
            onClose={handleClose}
            className="MuiModal"
        >
            <Box className="InsideContainer">
                <Box className="Header">
                    <Typography align='center' variant='h4'>{title}</Typography>
                    {/* {subtitle ? <Typography align="center">{subtitle}</Typography> : null} */}

                    <Button className="CrossButton" onClick={handleClose}>x</Button>
                </Box>
                <Box className="Body">
                    {children}
                </Box>
                {leftButtonLabel || rightButtonLabel ? <Stack className="Footer">
                    <Box>
                        {leftButtonLabel &&
                            <MixPanelTrackedLink
                                type="button"
                                label={leftButtonLabel}
                                context={`${title} Modal`}
                                variant='outlined'
                                disabled={leftButtonLoading}
                                onClick={onClickLeft}
                                sx={{ whiteSpace: 'nowrap' }}
                                fullWidth>
                                {leftButtonLoading ? <CircularProgress size={25} /> : leftButtonLabel}
                            </MixPanelTrackedLink>
                        }
                    </Box>
                    {rightButtonLabel &&
                        <Box><MixPanelTrackedLink
                            type="button"
                            label={rightButtonLabel}
                            context={`${title} Modal`}
                            variant='contained'
                            onClick={onClickRight || handleClose}
                            disabled={loadingRight || disabledRight}
                            fullWidth>
                            {loadingRight ? <CircularProgress sx={{ color: 'white' }} size={25} /> : rightButtonLabel}
                        </MixPanelTrackedLink></Box>}
                </Stack> : null}
            </Box>
        </StyledModal>
    </React.Fragment >
}